// extracted by mini-css-extract-plugin
export var statItem = "_mn-1";
export var statsRow = "_mn-0";